var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVoiceAssistant = function SvgIconVoiceAssistant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.002 10.971c.276 0 .5.231.5.516v2.271a5.1 5.1 0 0 0 .277 1.673c.636 1.849 2.296 3.154 4.223 3.154 1.923 0 3.58-1.3 4.22-3.144l.008-.028a5.1 5.1 0 0 0 .272-1.655v-2.27c0-.286.224-.517.5-.517s.5.231.5.516v2.271q0 .104-.003.206c-.096 2.949-2.244 5.366-4.997 5.63v3.248a.51.51 0 0 1-.5.516.51.51 0 0 1-.5-.516v-3.248c-2.161-.207-3.95-1.742-4.665-3.819l-.007-.02a6.2 6.2 0 0 1-.328-1.997v-2.27c0-.286.224-.517.5-.517",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.502 6.326c0-1.996 1.567-3.613 3.5-3.613s3.5 1.617 3.5 3.613v7.226c0 1.995-1.567 3.613-3.5 3.613q-.063 0-.124-.003c-1.876-.067-3.376-1.658-3.376-3.61zm3.435 9.805.065.001c1.38 0 2.5-1.155 2.5-2.58V6.326c0-1.425-1.12-2.58-2.5-2.58s-2.5 1.155-2.5 2.58v7.226c0 1.403 1.084 2.544 2.435 2.58",
    clipRule: "evenodd"
  })));
};
export default SvgIconVoiceAssistant;